// Skoda OpenID Connect Configuration
// Official configuration based on Skoda IT specifications
// Using Authorization Code Flow (recommended by Firebase)
// Reference: https://firebase.google.com/docs/auth/web/openid-connect

export const skodaOidcConfig = {
  // Provider ID - UPDATE THIS with the exact ID from Firebase Console after setup
  // Firebase will generate this when you create the OIDC provider
  providerId: "oidc.skoda",

  // Official Skoda OIDC configuration
  issuer: "https://identity.skoda.vwgroup.com/realms/standard",
  clientId: "aisoftskilltrain-2e257f39",
  // Client secret: Will be provided by Skoda IT (required for Firebase OIDC)

  // Scopes - Skoda-specific scopes from their identity provider
  // Based on example response: "openid email sa_roles sa_profile profile"
  scopes: ["openid", "email", "profile", "sa_roles", "sa_profile"],

  // Custom parameters for code flow
  // Note: Firebase handles response_type, redirect_uri, state, scope, and response_mode
  // automatically for code flow - do NOT override these parameters
  customParameters: {
    // Add any provider-specific parameters here if needed (e.g., login_hint)
    // Do not set: client_id, response_type, redirect_uri, state, scope, response_mode
  },
};

// Expected response fields from Skoda OIDC:
export const skodaResponseFields = {
  // Standard OIDC fields
  sub: "Unique user identifier",
  email: "User email address", // User can have multiple emails but only one preferred_username
  email_verified: "Email verification status",
  name: "Full name",
  given_name: "First name",
  family_name: "Last name",

  // Skoda-specific fields
  unique_identifier: "Employee unique ID",
  preferred_username: "Username (e.g., DZCKCAN)",
  display_name: "Display name with organization",
  employee_number: "Employee number",
  employee_type: "Employee type (e.g., P for external)",
  department_number: "Department code (e.g., FIG)",
  organization: "Organization name (e.g., SKODA AUTO)",
  locale: "User locale (e.g., CS)",
};

export default skodaOidcConfig;
